<x-page-layout class="my-5">
  <x-page-row>
    <x-page-panel
      [heading]="heading"
      [headingAlignment]="alignment"
      [subHeading]="subHeading"
      class="px-4 px-lg-0"
    >
      <div class="body d-flex flex-column" [class]="'align-items-' + bodyAlignment">
        <ng-container *ngIf="newProductsMenuNode$ | async as node; else ELSE">
          <ng-container *ngIf="backToShopping; else NEW_PRODUCTS">
            <p i18n="@@NotFound.HeadBack.SeeLatestProducts" [class]="'text-' + bodyAlignment">
              Head back to shopping or take a look at our latest products.
            </p>
            <div class="actions" [class]="'justify-content-' + bodyAlignment">
              <button mat-stroked-button color="primary" xGoHomeLink>Back to shopping</button>
              <button
                mat-flat-button
                color="primary"
                [routerLink]="node.url"
                i18n="@@CallToAction.LatestProducts"
              >
                Latest products
              </button>
            </div>
          </ng-container>

          <ng-template #NEW_PRODUCTS>
            <p i18n="@@NotFound.SeeLatestProducts" [class]="'text-' + bodyAlignment">
              Take a look at our latest products.
            </p>
            <div class="actions">
              <button
                mat-flat-button
                color="primary"
                [routerLink]="node.url"
                i18n="@@CallToAction.LatestProducts"
              >
                Latest products
              </button>
            </div>
          </ng-template>
        </ng-container>

        <ng-template #ELSE>
          <ng-container *ngIf="backToShopping">
            <p i18n="@@NotFound.HeadBack" [class]="'text-' + bodyAlignment">
              Head back and continue shopping.
            </p>

            <button
              mat-flat-button
              color="primary"
              xGoHomeLink
              i18n="@@CallToAction.BackToShopping"
            >
              Back to shopping
            </button>
          </ng-container>
        </ng-template>

        <div class="actions" [class]="'justify-content-' + bodyAlignment">
          <ng-content select="[xAction]"></ng-content>
        </div>
      </div>
    </x-page-panel>
  </x-page-row>
</x-page-layout>
